import {
  AfterViewInit,
  ChangeDetectorRef,
  Directive,
  ElementRef,
  HostBinding,
  HostListener,
  Input,
  OnInit,
} from '@angular/core';

@Directive({
  selector: '[aspectRatio]',
})
export class RxAspectRatioDirective implements AfterViewInit {
  @Input() aspectRatioValue = 1.4;

  @HostBinding('style.height.px')
  @Input()
  skipAspectRatio: boolean;
  elHeight: number;

  constructor(
    private elementRef: ElementRef,
    private cdr: ChangeDetectorRef,
  ) {}

  ngAfterViewInit(): void {
    this.onResize();
    this.cdr.detectChanges();
    setTimeout(() => this.onResize(), 300);
  }

  @HostListener('window:resize', ['$event.target'])
  public onResize() {
    if (!this.skipAspectRatio) {
      this.elHeight = this.elementRef.nativeElement.clientWidth / this.aspectRatioValue;
      this.elementRef.nativeElement.style.height = `${this.elHeight}px`;
    }
  }
}
